import React from "react";

export default function Footer() {
  return (
    <footer className="sd-footer" data-testid="site-footer">
      <p>
        © {new Date().getFullYear()} Sub Delicious Inc. |{" "}
        <span className="font-semibold">Lockport, New York</span>
      </p>
    </footer>
  );
}
